import React, { Fragment } from 'react';
import { isEmpty } from 'lodash/fp';
import PropTypes from 'prop-types';
import { Button, Icon, Whisper } from 'rsuite';
import jsonParse from '../../../helpers/jsonParse';
import { StringOrNumberType } from '../../../interfaces';
import HouseholdMembersPopover from '../../guest/HouseholdMembersPopover';
import LineChange from '../LineChange';

const HouseholdMemberChanges = ({ oldVal, newVal, label, type }) => {
  const oldMembers = jsonParse(oldVal) || [];
  const newMembers = jsonParse(newVal) || [];
  const isAddMembers = isEmpty(oldMembers) && type !== 'option_yesno';

  return (
    <LineChange>
      {isAddMembers ? '- Set' : '- Changed'} {` "${label}" `}
      {!isAddMembers && (
        <Fragment>
          from
          <Whisper
            enterable
            trigger="hover"
            placement="bottom"
            speaker={<HouseholdMembersPopover data={oldMembers} />}
          >
            <Button size="sm" appearance="link" style={{ padding: '0 5px' }}>
              hover to view <Icon icon="eye" />
            </Button>
          </Whisper>
        </Fragment>
      )}
      to
      <Whisper
        enterable
        trigger="hover"
        placement="bottom"
        speaker={<HouseholdMembersPopover data={newMembers} />}
      >
        <Button size="sm" appearance="link" style={{ padding: '0 5px' }}>
          hover to view <Icon icon="eye" />
        </Button>
      </Whisper>
    </LineChange>
  );
};

HouseholdMemberChanges.propTypes = {
  oldVal: StringOrNumberType.isRequired,
  newVal: StringOrNumberType.isRequired,
  label: PropTypes.string.isRequired,
  type: PropTypes.string.isRequired
};

export default HouseholdMemberChanges;
